import React, { useEffect, useState } from "react";
import axios from "axios";
import { useTranslation } from "react-i18next";
import CustomAlert from "./CustomAlert/CustomAlert";

const ApiErrorHandler = ({ children }) => {
  const { t } = useTranslation();
  const [error, setError] = useState({
    show: false,
    message: "",
    severity: "error",
  });

  useEffect(() => {
    const interceptor = axios.interceptors.response.use(
      (response) => response,
      (error) => {
        if (error.response && error.response.status === 429) {
          setError({
            show: true,
            message: t("too_many_requests"),
            severity: "error",
          });
        }
        return Promise.reject(error);
      }
    );

    return () => {
      axios.interceptors.response.eject(interceptor);
    };
  }, [t]);

  return (
    <>
      {error.show && (
        <CustomAlert
          severity={error.severity}
          message={error.message}
          duration={5000}
          onClose={() => setError((prev) => ({ ...prev, show: false }))}
        />
      )}
      {children}
    </>
  );
};

export default ApiErrorHandler;
